<template>
    <div
        v-if="isDefault"
        class="effect-box"
    >
        <div v-if="!currentTime">
            -
        </div>
        <div v-else>
            <div class="virtualNumber">
                虚拟号：{{ virtualNumber }}
            </div>
            <div class="sffect-time">
                生效时间：<span class="time">{{ currentTime }}</span>
            </div>
        </div>
    </div>
    <div v-else class="last-time">{{ currentTime }}</div>
</template>
<script>
import 'veui-theme-dls-icons';
/**
 * @file loading
 * @author liusihao
 */

export default {
    components: {
    },
    props: {
        virtualNumber: {
            'type': String,
            'default': ''
        },
        endTime: {
            'type': Number,
            'default': 1240
        },
        isDefault: {
            'type': Boolean,
            'default': true
        }
    },
    data() {
        return {
            time: 0,
            currentTime: 0
        };
    },
    computed: {
    },
    methods: {
        handleTime(time) {
            let mm = Math.floor(time / 60);
            let ss = time % 60;
            return (mm < 10 ? '0' + mm : mm) + '分' + (ss < 10 ? '0' + ss : ss) + '秒';
        }
    },
    mounted() {
        this.time = this.endTime - Math.floor(Date.now() / 1000);
        if (this.time < 0) {
            this.currentTime = '';
            this.timeInterval = null;
            return;
        }
        this.currentTime = this.handleTime(this.time--);
        this.timeInterval = setInterval(() => {
            if (this.time === 0) {
                clearInterval(this.timeInterval);
                this.currentTime = '';
                return;
            }
            this.currentTime = this.handleTime(this.time--);
        }, 1000);
    },
    destroyed() {
        clearInterval(this.timeInterval);
        this.currentTime = 0;
        this.time = 0;
    }
};
</script>
<style lang="stylus" scoped>
.time {
    color: #ff321b;
}
.last-time {
    color: #3855d5;
    font-size: 14px;
}
</style>
